module.exports = __webpack_public_path__ + "static/media/banner-img.3177316b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-img.png
// module id = 836
// module chunks = 7